import React, { FC } from 'react';
import { IIconProps } from 'app/components/svgs/Icon';

const Text: FC<IIconProps> = ({ size = '100%', width = size, height = size, ...props }) => (
  <svg width={width} height={height} viewBox="0 0 16 16" preserveAspectRatio="xMidYMid meet" {...props}>
    <path
      fill="#000000"
      d="M5.032 13l0.9-3h4.137l0.9 3h1.775l-3-10h-3.488l-3
           10h1.776zM7.432 5h1.137l0.9 3h-2.937l0.9-3z"
    />
  </svg>
);

export default Text;
